import {useLocation} from "@khan/urls";

const MIN_SCALE = 0.3;
const MAX_SCALE = 4;

export const MobileFontScale = ({selector = "body"}: {selector?: string}) => {
    const location = useLocation();
    const fontScale = Number(location.queryParams.fontScale);
    if (Number.isFinite(fontScale) && fontScale !== 1) {
        return (
            <style>{`${selector} { zoom: ${Math.max(
                MIN_SCALE,
                Math.min(fontScale, MAX_SCALE),
            )}; }`}</style>
        );
    }
    return null;
};
